import { createFileRoute } from '@tanstack/react-router'
import { RacaoPageContent } from '@/features/racao/racao-page'

export const Route = createFileRoute('/_authenticated/racao')({
  component: RacaoPageContent,
})
